export default "/images/framework/MyGameRankingEng.6b29ad11.svg?6b29ad11";